export default __webpack_public_path__ + "static/media/EFUG.1887b287.png";